<template>
  <div class="employeeIndex">
    <div class="page-search-block">
      <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
      <div class="inline-block">
        <span class="w-90 inline-block align-r">中心名称：</span>
        <el-input v-model="filters.search.pushName" class="w-120" placeholder="请输入" ></el-input>
      </div>
      <el-button class="submit-btn m-l-10" size="large" type="primary" @click="handleSearch">搜 索</el-button>
    </div>
    
    <div class="page-operate-block">
      <div class="tit">推送配置列表</div>
      <div>
        <el-button
          class="operate-btn"
          v-permission="'add'"
          @click="handleEdit('add')"
          >新增</el-button
        >
        <el-button
          class="operate-btn"
          :disabled="options.selection.length != 1"
          v-permission="'update'"
          @click="handleEdit('edit')"
          >编辑</el-button
        >
        <el-button
          class="operate-btn"
          :disabled="options.selection.length < 1"
          v-permission="'delete'"
          @click="handlePatchDelete(true)"
          >删除</el-button
        >
        <el-button
          class="operate-btn"
          :disabled="options.selection.length < 1"
          v-permission="'dataPush'"
          @click="handlePush(true)"
          >手动推送</el-button
        >
      </div>
    </div>
    
    <div class="table-list-block">
      <r-table
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      >
        <template v-for="item in tableColumn" :key="item.id">
          <el-table-column prop="province" label="部署区域" v-if="item.prop === 'province'">
            <template #default="scope">
              <span>{{scope.row.province + scope.row.city + scope.row.region}}</span>
            </template>
          </el-table-column>
          <el-table-column :prop="item.prop" :label="item.label" v-else>
            <template #default="scope">
              <span>{{scope.row[item.prop]}}</span>
            </template>
          </el-table-column>
        </template>
      </r-table>
    </div>

    <!--查看-->
    <!--<RModal title="详情" v-model="detailModal" :closeOnClick="false" @change="detailModal = false"  @close="closeModel">-->
    <Modal
      :modalTitle="modalTitle"
      modalId="detailModalId"
      class="smallModalDialog"
      @close="detailModal = false"
      :width="'60%'"
    >
      <detail-view
        v-if="detailType == 'show'"
        :detailModal="detailModal"
        :detailData="detailData"
        :selOptions="selOptions"
      ></detail-view>
      <edit-view
        v-else-if="detailType == 'add' || detailType == 'edit'"
        :detailType="detailType"
        :detailModal="detailModal"
        :detailData="detailData"
        :selOptions="selOptions"
        @submitSuccess="submitSuccess"
        @closeModel="closeModel"
      >
      </edit-view>
      <push-view
        v-else-if="detailType == 'push'"
        :detailType="detailType"
        :detailModal="detailModal"
        :selRows="options.selection"
        @submitSuccess="submitSuccess"
        @closeModel="closeModel"
      ></push-view>
    </Modal>
    <!--</RModal>-->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import RModal from '@/components/common/RModal'
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import checkMix from '@/components/common/checkAll.js'
import detailView from './detailView'
import editView from './editView'
import pushView from './pushView'
export default {
  name: 'pushIndex',
  mixins: [tableMix, checkMix],
  components: { RTable, detailView, RModal, editView, pushView },
  data() {
    let detailKeys = ['xm', 'cyzjdm', 'zjhm', 'dwmc', 'shxydm', 'rylx', 'dwbgdzQbm', 'rzsj']
    let searchData = {}
    detailKeys.map((key) => {
      searchData[key] = ''
    })
    return {
      perms: [],

      modalTitle: '详情',
      detailModal: false,
      detailType: 'show',
      uploadModal: false,
      downloadUrl: '',
      detailData: {},
      deleteUrl: 'PUSH.CONFIG.DELETE',
      areUOk: false,
      tableVarity: 'baseinfo_employee',
      tableColumn: [],
      tableData: [],
      selOptions: {},
      selOptionMaps: {},
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      // 查询参数
      filters: { search: searchData },
    }
  },

  watch: {
    detailModal(val) {
      if (this.detailType == 'add') {
        this.modalTitle = '新增'
      } else if (this.detailType == 'edit') {
        this.modalTitle = '编辑'
      } else if (this.detailType == 'push') {
        this.modalTitle = '手动推送'
      } else {
        this.modalTitle = '详情'
      }

      if (val) {
        $('#detailModalId').modal({ backdrop: 'static', show: true })
      } else {
        $('#detailModalId').modal('hide')
      }
    },
  },
  created() {
    this.perms = 'perms' in localStorage && localStorage.perms !== '' ? JSON.parse(localStorage.perms) : []
    this.initTableColumns()
    this.getDataList()
  },
  mounted() {

  },
  methods: {
    ...mapActions(['importUpload']),
    // 是否显示这个按钮
    isShowBtn(perm) {
      let url = window.location.pathname.substr(5)
      let len = this.perms.length
      let pid = ''
      for (let i = 0; i < len; i++) {
        if (this.perms[i].url == url) {
          pid = this.perms[i].id
        }
      }
      for (let i = 0; i < len; i++) {
        if (this.perms[i].pid == pid && this.perms[i].perm == perm) {
          return true
        }
      }

      return false
    },
    // 查询列表数据
    getQuery() {
      this.options.loading = true
      let params = this.getQueryParams2()

      let url = 'PUSH.CONFIG.GET_LIST'
      this.fetchData({
        url,
        method: 'get',
        params,
      })
        .then((res) => {
          this.options.loading = false
          if (this.toExcel == true) {
            if (!res || !res.data) {
              this.$message.error('操作失败！')
            } else {
              window.location.href = res.data
            }
            this.toExcel = false
            return
          }

          if (!res || !res.data) {
            this.tableData = []
            this.pagination.total = 0
          } else {
            this.tableData = res.data || []
            this.pagination.total = res.rowCount
          }
        })
        .catch((err) => {
          console.log(err, 'errorInfo')
        })
        .finally(() => {
          this.options.loading = false
          this.toExcel = false
        })
    },
    // 初始化自定义表头
    initTableColumns() {
      let columns = [
        { prop: 'pushName', label: '名称', visible: true, minWidth: 160, isInput: true },
        { prop: 'province', label: '部署区域', visible: true, minWidth: 160, isSelect: false },
        { prop: 'pushIp', label: 'IP地址', visible: true, minWidth: 160, isInput: false },
        { prop: 'pushAccount', label: 'FTP账号', visible: true, minWidth: 160, isInput: false },
        { prop: 'pushPort', label: 'FTP端口', visible: true, minWidth: 160, isSelect: false },
        { prop: 'expand', label: '备注', visible: true, minWidth: 160, isInput: false },
      ]

      columns.forEach((item) => {
        if (item.prop == 'name') {
          item.render = (row, index, column) => {
            return <a onClick={this.handleShowDetail.bind(this, row)}>{row[column.prop]}</a>;
          }
        } else if (item.prop == 'regionName') {
          item.render = (row, index, column) => {
            return <span>{row.provinceName} {row.cityName} {row.regionName}</span>;
          }
        }
      })

      this.tableColumn = columns
    },
    handleShowDetail(row) {
      this.detailData = { ...row }
      console.log(row, 'rrr---------')
      this.$nextTick(() => {
        this.detailType = 'show'
        this.detailModal = true
      })
    },
    handleEdit(detailType) {
      this.$nextTick(() => {
        this.detailType = detailType
        this.detailModal = true
        if (detailType == 'edit' && this.options.selection.length) {
          this.detailData = { ...this.options.selection[0] }
        } else {
          this.detailData = {}
        }

      })
    },
    submitSuccess() {
      this.detailModal = false
      this.detailType = ''
      this.getDataList()
    },
    closeModel() {
      this.detailModal = false
    },
    handlePush() {
      this.$nextTick(() => {
        this.detailType = 'push'
        this.detailModal = true
      })
    },
  }
}
</script>

<style lang="less" scoped>
.log-title {
  font-size: 22px;
  font-weight: 600;
}
</style>
